import { TitlePage } from 'components/atoms'
import { InputField, InputSelectOptions, LoaderButton } from 'components/molecules'
import { GENDER, REFERRER, SELLER_TYPE } from 'domains/seller/constants'
import ContractField from 'domains/seller/molecules/contract-field'
import PropTypes from 'prop-types'

const propTypes = {
  formikBag              : PropTypes.object.isRequired,
  copyUserProfileOnClick : PropTypes.func.isRequired
}

const SellerCreateFields = ({
  formikBag,
  copyUserProfileOnClick
}) => (
  <>
    <TitlePage mainTitle={ 'Seller Profile' } />

    <LoaderButton
      className='float-right mb-4'
      color='primary'
      text={ 'Copy User Profile' }
      onClick={ () => { copyUserProfileOnClick(formikBag) } }
    />

    <InputField
      type='text'
      name='seller.name'
      label='Name'
      placeholder='Tinkerlust'
      required={ true }
    />
    <InputField
      type='text'
      name='seller.email'
      label='Email'
      placeholder='tinkerlust@gmail.com'
      required={ true }
    />
    <InputField
      type='tel'
      name='seller.mobile'
      label='Phone Number'
      placeholder='62821xxxxxx'
      required={ true }
    />
    <InputField
      type='date'
      name='seller.birthday'
      label='Birthday'
      required={ true }
    />
    <InputField
      type='select'
      name='seller.gender'
      label='Gender'
      required={ true }
    >
      <InputSelectOptions options={ GENDER } keyPrefix={ 'gender' } />
    </InputField>
    <InputField
      type='text'
      name='seller.username'
      label='Username'
      placeholder='username123'
      required={ true }
      formText='Ini untuk url toko.
      tinkerlust.com/sellers/username123'
    />
    <InputField
      type='select'
      name='seller.seller_type'
      label='Seller Type'
      required={ true }
    >
      <InputSelectOptions options={ SELLER_TYPE } keyPrefix={ 'seller-type' } />
    </InputField>
    <InputField
      type='select'
      name='seller.referrer'
      label='Referrer'
      required={ true }
    >
      <InputSelectOptions options={ REFERRER } keyPrefix={ 'referrer' } />
    </InputField>
    <ContractField
      name='seller.contract_id'
      formikBag={ formikBag }
      fieldName={ 'seller.contract_id' }
      sellerType={ formikBag.values.seller_type }
    />
  </>
)

SellerCreateFields.propTypes = propTypes

export default SellerCreateFields